const i = {
  "diagnostics-item": "diagnostics-item",
  "diagnostics-item__product": "diagnostics-item__product",
  "diagnostics-item__badge": "diagnostics-item__badge",
  "diagnostics-item__name": "diagnostics-item__name",
  "diagnostics-item__description": "diagnostics-item__description",
  "diagnostics-item__fields": "diagnostics-item__fields",
  "diagnostics-item__field": "diagnostics-item__field",
  "diagnostics-item__field-label": "diagnostics-item__field-label",
  "diagnostics-item__field-value": "diagnostics-item__field-value",
  "diagnostics-item--near-patient-care": "diagnostics-item--near-patient-care",
  "diagnostics-item--pathology-lab": "diagnostics-item--pathology-lab",
  "diagnostics-item--digital-solution": "diagnostics-item--digital-solution",
  "diagnostics-item--core-lab": "diagnostics-item--core-lab",
  "diagnostics-item--molecular-lab": "diagnostics-item--molecular-lab",
  "diagnostics-item--diagnostics-insights": "diagnostics-item--diagnostics-insights",
  "diagnostics-item--healthcare-insights": "diagnostics-item--healthcare-insights",
  "diagnostics-item--other": "diagnostics-item--other"
};
export {
  i as default
};
